import React, { FC, useContext, useMemo, useCallback, ComponentType } from 'react';
import { useDispatch } from 'react-redux';

import submitFormById from '../../../actions/form-fn/submitFormById';
import useScopedSelector from '../../../hooks/useScopedSelector';
import throwError from '../../../utils/error/#throwError';
import FormContext from '../../form/FormContext';

export interface SubmitButtonProps {
  Button: ComponentType<any>;
}

const SubmitButton: FC<SubmitButtonProps> = ({ Button, ...props }) => {
  const { parentFormId, ancestorFormId, isolatedSubForm, formScope } = useContext(FormContext);
  const dispatch = useDispatch();
  const dispatchSubmitFormById = useCallback((...args: Parameters<typeof submitFormById>) => dispatch(submitFormById(...args)), [dispatch]);

  const rootScope = formScope[0];
  const isSubmitting: boolean = useScopedSelector(`${rootScope}.isSubmitting`);

  if (!parentFormId) {
    throwError('SubmitButton: This component must be placed inside a "Form".');
  }

  const isHtmlForm = useMemo(() => (parentFormId === ancestorFormId && !isolatedSubForm), [ancestorFormId, isolatedSubForm, parentFormId]);
  const type = useMemo(() => (isHtmlForm ? 'submit' : 'button'), [isHtmlForm]);
  const handleClick = useCallback(() => {
    if (!isHtmlForm) {
      dispatchSubmitFormById(parentFormId);
    }
  }, [dispatchSubmitFormById, isHtmlForm, parentFormId]);

  return (
    <Button
      type={type}
      busy={isSubmitting}
      {...props}
      onClick={handleClick}
    />
  );
};

export default SubmitButton;
